export class Depreciation {
  id: string;
  date: string;
  inv_details: any;
  item_id: string;
  time: string;

  depreciation_reason_details: any;
  branch_id: any;
  organization_id: any;

  from_date:string;
  to_date:string;

  creation_user: string;
  creation_ip: string;
  created_at: string;

  last_update_user: string;
  last_update_ip: string;
  last_on_behalf_of: string;
  showDeletedOnly: boolean;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/depreciation/depreciation.ts